import { render, staticRenderFns } from "./ReportRatingsSubject.vue?vue&type=template&id=7ac5b050&scoped=true"
import script from "./ReportRatingsSubject.vue?vue&type=script&lang=js"
export * from "./ReportRatingsSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac5b050",
  null
  
)

export default component.exports